import { Stack, Typography } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type ValueNotProvidedProps = {
	color: string;
};

export const ValueNotProvided = ({ color }: ValueNotProvidedProps) => {
	const { t } = useResource();

	return (
		<Stack>
			<Typography fontSize={14} fontWeight={600} color={color}>
				{t(Resources.Common.ValueNotProvided)}
			</Typography>
			<Typography fontSize={12} fontWeight={400} color={color}>
				{t(Resources.Common.ValueNotProvidedSubtitle)}
			</Typography>
		</Stack>
	);
};
